<div class="modal-header">
  <h4 class="modal-title">{{ title }}</h4>
  <button (click)="close()" aria-label="Close" class="modal-close" type="button">
    <font-awesome [icon]="'fa-regular fa-xmark'"></font-awesome>
  </button>
</div>

<div class="modal-body">
  <div class="item-row">
    <div class="item-label">Product type</div>
    <div class="item-value">
      <div [ngClass]="{ 'has-error': !selectedProductType }" class="mb-3 position-relative d-flex flex-row">
        <ng-select (ngModelChange)="setProductType($event)"
                   [(ngModel)]="selectedProductType"
                   [items]="productType"
                   bindLabel="product"
                   placeholder="Select Product Type">
        </ng-select>
      </div>
    </div>

    <div class="item-label">Date</div>
    <div class="item-value">
      <div class="input-group input-calendar-condition">
        <input
          #startDatePicker="bsDatepicker"
          [bsConfig]="bsConfig"
          [formControl]="startDate"
          [maxDate]="startMaxDate"
          [minMode]="'month'"
          [readOnly]="true"
          bsDatepicker
          class="form-control input-search-condition py-2 pl-16px"
          placeholder="Select Date"
          placement="bottom"
          required
          type="text"/>
        <span class="input-group-text bg-transparent">
                                  <img (click)="startDatePicker.toggle()"
                                       [attr.aria-expanded]="startDatePicker.isOpen"
                                       class="duration-icon"
                                       src="assets/img/ico-duration.svg"/>
                                </span>
      </div>
    </div>
  </div>

</div>

<div class="modal-footer">
  <div class="d-flex justify-content-end w-100">
    <button (click)="deleteAllData()" class="btn btn-185px btn-dark" type="button">Delete All Data</button>
    <button (click)="deleteData()" [disabled]="!selectedProductType || !startDate"
            class="btn btn-185px btn-outline-dark ml-24px" type="button">Delete
    </button>
  </div>
</div>
